export enum StatusUsuario{
    AguardandoAprovacao = 0,
    Aprovado = 1,
    Reprovado = 2,
    Inativado = 3
}